module.exports = __webpack_public_path__ + "img/1571203787.53588d0d.jpg";